import axios from "axios";
import cogoToast from "cogo-toast";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Folder from "../../src/asstes/Folder2.png";
import Home from "../../src/asstes/Home.png";
import LeftArrow from "../../src/asstes/LeftArrow.png";
import SidePanel from "../components/ModCardPanel/SidePanel";
import {
  AWS_Access_Key_Id,
  AWS_Bucket_Name,
  AWS_Secret_Access_Key,
} from "../constants/bucketCostant";
import {
  BlockChain,
  keyImages,
  UploadApi,
  ViewerURL,
} from "../constants/Constants";

const EyeFrame = ({ iframeValue, password, setTab, setDisplayIFrame, tab }) => {
  const { FolderName, modality, subFolder, thirdFolder, fourthFolder } =
    useParams();

  const parts = FolderName?.split("%");
  const email = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let aa = useParams();
  const [isSidePanelOpen, setIsSidePanelOpen] = React.useState(false);
  const [SSuid, setSsuid] = React.useState("");

  const [forViewerUrl, setViewerUrl] = useState("");

  const toggleSidePanel = (data) => {
    setSsuid(data);
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  // const goBack = () => {
  //   // Use navigate to go back to the previous page
  //   if (
  //     window.location.href.includes("/SubFolder&studies") ||
  //     window.location.href.includes("/StudyTable")
  //   ) {
  //     setTab(4);
  //     // navigate(`/dynamicModality/${lab}`);

  //     navigate(`/SubFolder&studies/${FolderName}`);
  //   } else {
  //     setTab(5);
  //   }

  //   // setDisplayIFrame=false;
  //   // dispatch(setbuttonTop(false));
  // };
  const goBack = () => {
    // Use navigate to go back to the previous page
    // navigate(`/dynamicModality/${lab}`);
    // setToggle(false);
    // setMainFolder(false);
    // if (window.location.href.includes("/SubFolder&studies")) {
    if (window.location.href.includes(encodeURIComponent(subFolder))) {
      setTab(4);
      setDisplayIFrame(false);
      navigate(
        `/SubFolder&studies/${parts}${
          subFolder && subFolder != "undefined" ? `/${subFolder}` : ""
        }${thirdFolder && thirdFolder != "undefined" ? `/${thirdFolder}` : ""}${
          fourthFolder && fourthFolder != "undefined" ? `/${fourthFolder}` : ""
        }`
      );
    } else if (window.location.href.includes(FolderName)) {
      setTab(4);
      setDisplayIFrame(false);
      navigate(`/SubFolder&studies/${parts}`);
      // dispatch(setbuttonTop(false));
    } else {
      navigate("/");
      // dispatch(setbuttonTop(false));
      setTab(0);
      setDisplayIFrame(false);
    }
  };

  const state = useSelector((state) => state.foldersave.folder);

  const FolderGet = useSelector((state) => state.FolderGet.FolderName);

  const fetchDataFromApi = async () => {
    const token = localStorage.getItem("token");
    const requestBody = {
      args: [state],
      email: email,
      orgName: "dcm",
      fcn: "viewDocument",
    };

    // try {
    //   const url = `https://app.dcmcloud.com/fileloaderv1/folders/GetImagesAndDataInFolder/?awsAccessKeyId=${AWS_Access_Key_Id_Encypt()}&awsSecretAccessKey=${AWS_Secret_Access_Key_Encypt()}&bucketName=${process.env.React_App_AWS_Bucket_Name_encypt}&folderPath=${folderPath}${state}/Reports&Region=us-east-1`;
    //   //console.log("Fetching data from:", url);

    //   const response = await fetch(url, {
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });

    //   //console.log("Response status:", response);

    //   const data = await response.json();
    //   //console.log("This is data", data);
    //   // Pass ssuid to toggleSidePanel
    //   toggleSidePanel(data);
    //   // //console.log("API data:", data);

    //   // setApiData(data);
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    // }
    try {
      let token = localStorage.getItem("token");
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const promises = [];

      const folderPath = parts ? `${parts}/` : "";

      const formData = {
        AwsBucket: AWS_Bucket_Name(),
        suid: `${folderPath}${state}/Reports`,
      };

      const response = await axios.post(
        `${keyImages}/keyImages/v1/PdfNode/getPdf`,
        JSON.stringify(formData),
        { headers }
      );

      if (response) {
        toggleSidePanel(response.data);
        // setMessage("Folder Updated Successfully");
        setTimeout(() => {
          // setIsOpen(false);
        }, 3000);
      }
    } catch (error) {
      cogoToast.error("PDF not found in this study", {
        position: "top-right",
      });
      console.error("Error while deleting folder:", error);
    }
    try {
      const response = await axios.post(
        `${BlockChain}/api/view-document`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getToken = async () => {
    try {
      const response = await axios.get(`${UploadApi}/user/getAuth`, {
        headers: {
          "x-api-key": process.env.React_App_Api_Key,
        },
      });

      if (response.data) {
        return response.data.token;
      } else {
        console.error("Error: No data in response");
      }
    } catch (error) {
      console.error("Error fetching token:", error);
    }
  };

  const getURL = async () => {
    // const base64 =
    //   process.env.React_App_AWS_Bucket_Name +
    //   "^" +
    //   process.env.React_App_User_AWS_Access_Key_Id +
    //   "^" +
    //   process.env.React_App_User_AWS_Secret_Access_Key +
    //   "^" +
    //   process.env.React_App_User_DCMC_Access_Key;
    // const token = await getToken();
    // const base64String = btoa(base64);
    // const url = `${ViewerURL}/xrad/viewer/${FolderName}()${
    //   subFolder != "undefined" ? `${subFolder}()` : ""
    // }${state}%5E${base64String}?Finalized=false&token=${token}`;
    // setViewerUrl(url);

    const token = await getToken();
    const url = `${ViewerURL}/xrad/viewer?StudyInstanceUIDs=${state}&bucketId=${
      process.env.React_App_Bucket_Id
    }&isFinalized=false&authToken=${token}&folderPath=${FolderName}()${
      subFolder && subFolder != "undefined" ? `${subFolder}()` : ""
    }${thirdFolder && thirdFolder != "undefined" ? `${thirdFolder}()` : ""}${
      fourthFolder && fourthFolder != "undefined" ? `${fourthFolder}()` : ""
    }&clientName=mrc`;
    setViewerUrl(url);
  };

  useEffect(() => {
    getURL();
  }, []);

  const match = parts?.find((item) => item.includes("--ONLYSHARE--")) || "";
  const result = match ? match.split("--ONLYSHARE--")[0] : parts;

  const determinePath = () => {
    try {
      if (FolderGet) {
        const parts = FolderGet.split("/");
        const count = parts.length;
        const lastPart = parts[parts.length - 1];

        const hierarchies = [result, subFolder, thirdFolder, fourthFolder];

        const remaining = hierarchies.slice(count);

        const newPath = [lastPart, ...remaining].join("/");
        return newPath;
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div style={{ height: "87vh" }} className="abcd">
        <div className="w-full text-xs md:test-sm text-purple-800 bg-white border h-12 rounded-xl mb-2 shadow-md ">
          <div className="inline-flex w-full h-full items-start justify-start ">
            <div className="flex cursor-pointer mx-3 my-auto" onClick={goBack}>
              {" "}
              <img src={LeftArrow} height="20px" width="20px" alt="img" />
            </div>

            <div className="flex cursor-pointer font-bold my-auto">
              {" "}
              <img
                src={Folder}
                className="mx-2"
                height="20px"
                width="20px"
                alt="img"
              />
              My Folder
            </div>
            <div
              className="flex cursor-pointer font-bold text-xs my-auto"
              onClick={() => {
                navigate(`/SubFolder&studies/${parts}`);
                console.log("clcikedd");
                // setTab(5);
                // navigate("/");
              }}
            >
              <img
                src={Home}
                className="mx-2"
                height="20px"
                width="22px"
                alt="img"
              />
              Home /
              {FolderGet ? (
                determinePath()
              ) : (
                <>
                  {parts && result}
                  {subFolder && subFolder != "undefined"
                    ? " / " + subFolder
                    : ""}
                  {thirdFolder && thirdFolder != "undefined"
                    ? " / " + thirdFolder
                    : ""}
                  {fourthFolder && fourthFolder != "undefined"
                    ? " / " + fourthFolder
                    : ""}
                </>
              )}
            </div>
          </div>
        </div>
        {/* <button style={{zIndex:"10" , position:"absolute" ,top:"165px",right:"400px",color:"white"}}onClick={goBack}>Back</button> */}
        {/* <SimCardDownloadIcon
          onClick={() => fetchDataFromApi()}
          className="text-white"
          style={{
            zIndex: "10",
            cursor: "pointer",
            position: "absolute",
            top: "165px",
            right: "390px",
            color: "white", // Change color to white
            height: "25px",
            width: "25px",
          }}
        /> */}

        {subFolder !== "undefined" || undefined ? (
          FolderName ? (
            <iframe
              style={{ height: "94%", width: "100%", border: "none" }}
              src={forViewerUrl}
              // src={`https://app.dcmcloud.com/mrc/viewer/${
              //   "demo2/" + state
              // }%bXJjLWRlbW9eQUtJQVFPUExLNkdGM1NVMklGUEZebkFCWlFiVFZHQ3ZUQzB2czcxRWZQNGl2WGsxWnhTam5IalR5cUo4cV44OTc0OTg3Mzk`}
            />
          ) : (
            <iframe
              style={{ height: "94%", width: "100%", border: "none" }}
              // src={`https://app.dcmcloud.com/mrc/viewer/Aaron()${state}%5EdGVzdC1tcmNeQUtJQVFPUExLNkdGM1NVMklGUEZebkFCWlFiVFZHQ3ZUQzB2czcxRWZQNGl2WGsxWnhTam5IalR5cUo4cV5lZG1lb2RtZG1tdXVkZG9j`}
              src={forViewerUrl}
            />
          )
        ) : (
          <iframe
            style={{ height: "94%", width: "100%", border: "none" }}
            src={forViewerUrl}
            // src={`https://app.dcmcloud.com/mrc/viewer/${
            //   "demo2/" + state
            // }%bXJjLWRlbW9eQUtJQVFPUExLNkdGM1NVMklGUEZebkFCWlFiVFZHQ3ZUQzB2czcxRWZQNGl2WGsxWnhTam5IalR5cUo4cV44OTc0OTg3Mzk`}
          />
        )}
      </div>
      <SidePanel
        isOpen={isSidePanelOpen}
        onClose={toggleSidePanel}
        ssuidDetail={SSuid}
      />
    </>
  );
};

export default EyeFrame;
